// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-ListItem-module--cls1--31vCF","cls2":"styles-ListItem-module--cls2--3xxCz styles-ListItem-module--cls1--31vCF"};